import axios from 'axios';

import config from 'utils/config';

import { PRINTER_PECTABS_PRINT_COMMAND, PRINTER_TEMPLATE_PRINT_COMMAND } from './printCommands';

const sendPecTabs = async () => {
  try {
    const { data } = await axios({
      url: config('ATB_PRINT_SERVICE'),
      method: 'POST',
      data: {
        printcommand: PRINTER_PECTABS_PRINT_COMMAND
      }
    });

    if (data.printerStatus === 'Error') {
      // eslint-disable-next-line no-console
      console.error('PRINTER_ERROR_SEND_PECTABS_FAILED', data);
      throw new Error('PRINTER_ERROR_SEND_PECTABS_FAILED');
    }

    return data;
  } catch (err) {
    // eslint-disable-next-line no-console
    console.error('PRINTER_ERROR_SEND_PECTABS_FAILED', err);
    throw new Error('PRINTER_ERROR_SEND_PECTABS_FAILED');
  }
};

const sendTemplate = async () => {
  try {
    const { data } = await axios({
      url: config('ATB_PRINT_SERVICE'),
      method: 'POST',
      data: {
        printcommand: PRINTER_TEMPLATE_PRINT_COMMAND
      }
    });

    if (data.printerStatus === 'Error') {
      // eslint-disable-next-line no-console
      console.error('PRINTER_ERROR_SEND_TEMPLATE_FAILED', data);
      throw new Error('PRINTER_ERROR_SEND_TEMPLATE_FAILED');
    }

    return data;
  } catch (err) {
    // eslint-disable-next-line no-console
    console.error('PRINTER_ERROR_SEND_TEMPLATE_FAILED', err);
    throw new Error('PRINTER_ERROR_SEND_TEMPLATE_FAILED');
  }
};

const sendCommand = async (printcommand) => {
  try {
    const { data } = await axios({
      url: config('ATB_PRINT_SERVICE'),
      method: 'POST',
      data: {
        printcommand
      }
    });

    if (data.printerStatus === 'Error') {
      // eslint-disable-next-line no-console
      console.error('PRINTER_ERROR_STATUS_CHECK', data);
      throw new Error('PRINTER_ERROR_STATUS_CHECK');
    }

    return 'PRINTER_SUCCESS';
  } catch (err) {
    // eslint-disable-next-line no-console
    console.error('PRINTER_ERROR_STATUS_CHECK', err);
    throw new Error('PRINTER_ERROR_STATUS_CHECK');
  }
};

const printTickets = async (printCommands) => {
  await sendPecTabs();
  await sendTemplate();

  return Promise.all(printCommands.map(sendCommand));
};

export default printTickets;
